(function () {
  const { Component } = window;

  const style = `
    :host {
      display: block;
      box-sizing: border-box;
      text-align: center;
    }

    :host([hidden]) { display: none; }

    :host(.stretch) {
      flex: 1;
    }

    /*
     * The interactive box lives on the slotted <a> when present, otherwise on
     * .text (plain-text tabs). Keeping padding/hit-area on a single element
     * means hover, cursor, focus ring and click all cover the same region.
     */
    .text {
      color: var(--tabBarTextColor);
      cursor: pointer;
      display: inline-block;
      text-transform: capitalize;
      font: var(--font-label-md);
      line-height: 1.29;
      letter-spacing: normal;
      min-width: 64px;
      padding: 12px;
      transition: color 0.2s ease-in-out;
      white-space: nowrap;

      @media (min-width: 768px) {
        font: var(--font-heading-sm);
      }
    }

    ::slotted(a) {
      color: inherit;
      cursor: pointer;
      display: block;
      /* Cancel .text padding then re-apply on the anchor so the anchor's own
         box is the full tab — no unclickable padding gaps. */
      margin: -12px;
      padding: 12px;
      text-decoration: none;
    }

    :host([active]) .text {
      color: var(--tabBarActiveTextColor);
    }

    :host(:not([active]):hover) .text {
      color: var(--tabBarActiveTextColor);
    }

    :host(:focus-visible),
    ::slotted(a:focus-visible) {
      outline: 2px solid var(--tabBarActiveTextColor);
      outline-offset: -2px;
      border-radius: 4px;
    }

    :host(:focus),
    ::slotted(a:focus) {
      outline: none;
    }
  `;

  const template = document.createElement('template');
  template.innerHTML = `
    <style>${style}</style>
    <div class="text">
      <slot></slot>
    </div>
  `;

  class TabBarOption extends Component {
    static get observedAttributes() {
      return ['active', 'hidden', 'value'];
    }

    static get propsCamelConventionEnabled() {
      return true;
    }

    constructor() {
      super();

      this.initBool(['active', 'hidden']);
    }

    template() {
      return template;
    }
  }

  if (!window.customElements.get('tab-bar-option')) {
    window.customElements.define('tab-bar-option', TabBarOption);
  }

  /* istanbul ignore next */
  if (typeof module !== 'undefined') {
    module.exports = TabBarOption;
  }
})();
